export enum ComponentIntance {
  Siempre = 0,
  SoloCreacion = 1,
  SoloEdicion = 2,
  Nunca = 3,
}
